import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (coversAnInstitution: boolean) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Reading these numbers',
    description: `Every figure covers ${
      coversAnInstitution ? 'the whole institution' : 'the students you coach'
    }, unfiltered. Each carries its own denominator, which differs by card, so quote a figure with the population it came from.`,
  });
};
